<template>
  <div v-if="show === true" class="carregando">
    <img :src="BP_LOGO" style="max-width: 90%" />
  </div>
</template>

<script>
import { BP_LOGO } from './../shared/global';

export default {
  name: 'loading',
  props: {
    show: Boolean,
  },
  data() {
    return {
      BP_LOGO,
    };
  },
};
</script>

<style>
.carregando {
  color: #fff;
  position: fixed;
  margin: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  z-index: 99999;
  text-align: center;
  padding-top: 50%;
}
</style>
